YP.NewsletterListManager = function() {
    return {
        init: function() {
            $('.js-newsletter-menu a').live('click', {
                klass: this
            }, this.changeMenu);

            $('.js-newsletter-paginator a').live('click', {
                klass: this
            }, this.loadList);

        },
        changeMenu: function(e) {
            e.preventDefault();
            klass = e.data.klass;
            url = $(this).attr('href');

            $('.js-newsletter-menu .c-tab__item').removeClass('is-active');
            $('.js-newsletter-container').html("");
            $(this).parent().addClass('is-active');

            $.ajax({
                url      : url,
                type     : 'GET',
                dataType : 'json',
                success  : function(data) {
                    $('.js-newsletter-container').html(data.view);
                }
            });

        },
        loadList: function(e) {
            e.preventDefault();
            url = $(this).attr('href');

            $.ajax({
                url      : url,
                type     : 'GET',
                dataType : 'json',
                success  : function(data) {
                    $('.js-newsletter-container').html(data.view);
                }
            });
        },
    }
};
window.addEventListener("load", function() {
    YP.NewsletterListManager().init();
});
